export type CheckoutState = {
    checkoutOpen: boolean;
    // Map of ticket id => quantity
    ticketPurchases: Map<number, number>;
    loading: boolean; 
    error: CheckoutError;
}

export type FetchTicketParams = {
    ticketId: number;
}

export enum CheckoutError {
    NONE,
    LOADING_FAILED = 'Ticket details loading has failed',
}

export type TicketPurchase = {
    ticketId: number,
    quantity: number
}
